export default "__VITE_ASSET__DdV82cPX__"